import * as React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Button from '@mui/material/Button';
import PlantListViewmodel from './Viewmodels/PlantListViewmodel';
import { useNavigate } from 'react-router-dom';
import PermissionCheck from '../Utilities/PermissionCheck';
import { Permission } from '../Permissions/Permissions';
import Grid from '@mui/material/Grid';
import CloseDialogConfirmation from '../Utilities/CloseDialogConfimation';
import { FilterContext } from '../Contexts/FilterContext';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import authService from '../api-authorization/AuthorizeService';

interface IProps {
    row: PlantListViewmodel;
    edit: (id: number) => void;
    archive: (id: number) => void;
    favourite: (id: number) => void;
}

export default function PlantsTableRow({ row, edit, archive, favourite }: IProps) {
    const { plant, updatePlant } = React.useContext(FilterContext);
    const navigate = useNavigate();
    const [openConfirmation, setOpenConfirmation] = React.useState(false);
    const [clicked, setClicked] = React.useState(false);
    const [isClient, setIsClient] = React.useState(true);

    React.useEffect(() => {
        updateAuth();
    }, []);

    const updateAuth = async () => {
        const user = await authService.getUser();
        var userType = user.role ? user.role : user.userType ? user.userType : '';
        setIsClient(userType === 'Client');
    }

    React.useEffect(() => {
        if (plant === row.id && clicked) {
            navigate(
                '/Assets',
                {
                    state: {
                        plantId: row.id
                    }
                }
            );
        }
    }, [plant]);

    React.useEffect(() => {
        if (clicked) {
            if (row.id === plant) {
                navigate(
                    '/Assets',
                    {
                        state: {
                            plantId: row.id
                        }
                    }
                );
            }
            else {
                updatePlant(row.id);
            }
        }
    }, [clicked]);

    const viewAssets = () => {
        setClicked(true);
    }

    const close = (refresh: boolean) => {
        setOpenConfirmation(false);
        if (refresh) {
            archive(row.id)
        }
    }

    return (
        <TableRow>
            {!isClient &&
                <TableCell>
                    <Tooltip title="Add as favourite">
                        <IconButton size="small" aria-label="favourite" onClick={() => favourite(row.id)}>
                            {row.favourite ? <StarIcon /> : <StarOutlineIcon />}
                        </IconButton>
                    </Tooltip>
                </TableCell>
            }
            <TableCell>{row.name}</TableCell>
            <TableCell>{row.clientName}</TableCell>
            <TableCell>{row.address}</TableCell>
            <TableCell align="right">{row.assetCount}</TableCell>
            <TableCell align="right">{row.nomEngineer}</TableCell>
            <TableCell align="right">{row.deptEngineer}</TableCell>
            <TableCell align="right">
                <Grid container spacing={1} justifyContent="flex-end">
                    <PermissionCheck permission={Permission.CreatePlants}>
                        <Grid item>
                            <Button variant="contained" size="small" onClick={() => edit(row.id)}>Edit Details</Button>
                        </Grid>
                    </PermissionCheck>
                    <PermissionCheck permission={Permission.DeleteClients}>
                        <Grid item>
                            <Button variant="contained" size="small" onClick={() => setOpenConfirmation(true)}>{!row.status ? "Archive" : "Unarchive"}</Button>
                        </Grid>
                    </PermissionCheck>
                    <Grid item>
                        <Button variant="contained" size="small" onClick={viewAssets}>View Assets</Button>
                    </Grid>
                </Grid>
            </TableCell>
            <CloseDialogConfirmation confirmClosureMessage={'Yes'} preventClosureMessage={'No'} title={'Are you sure you want to discard ' + row.name + ' ?'} open={openConfirmation} onClose={close}></CloseDialogConfirmation>

        </TableRow>
    );
}